export enum RouteName {
  App = 'app',
  Home = 'home',
  Dashboard = 'dashboard',

  Onboarding = 'onboarding',
  Tabs = 'tabs',
  PseudoTabAddTracking = 'pseudo-tab-add-tracking',

  Messaging = 'messaging',
  Messages = 'messages',
  NewMessageModal = 'new-message',

  Task = 'task',
  ActiveTask = 'active-task',
  TaskInfoModal = 'task-info',
  AnsweredTasks = 'answered-tasks',
  AnsweredTask = 'answered-task',

  Preview = 'preview',
  PreviewSearch = 'preview-search',
  PreviewTask = 'preview-task',

  Tracking = 'tracking',
  TrackingList = 'tracking-list',
  TrackingByType = 'tracking-by-type',
  TrackingDetails = 'tracking-details',
  TrackingInsights = 'tracking-insights',
  TrackingEventModal = 'tracking-event',

  Account = 'account',
  AccountList = 'account-list',
  Program = 'program',
  ContactUs = 'contact-us',

  Settings = 'settings',
  SettingsList = 'settings-list',
  Notifications = 'notifications',
  Appearance = 'appearance',
  Language = 'language',
  Units = 'units',
  GarminModal = 'garmin',

  About = 'about',
  AboutList = 'AboutList',
  Licenses = 'licenses',

  Playground = 'playground',

  // global modals
  WelcomeModal = 'welcome',
  UpdateAccountModal = 'update-account',
  AddTrackingModal = 'add-tracking',
}
